import React from "react";
import SelectClassInput from "nlib/common/SelectClassInput";

const SelectClass = (props) => {
  const {
    value,
    ...restProps
  } = props;

  return (
    <SelectClassInput
      value={value}
      invalid={!!(value?.name && !value?.id)}
      valid={!!(value?.name && value?.id)}
      {...restProps} />
  );
};

export default React.memo(SelectClass);
